import {Component, ElementRef, HostListener} from '@angular/core';
import {AccessibilityService} from '@commonShared/services/accessibility.service';
import {Select} from '@ngxs/store';
import {SharedState} from '@shared/store';
import {Observable} from 'rxjs';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {map} from 'rxjs/operators';

@Component({
  selector: 'cl-accessibility-control',
  templateUrl: './accessibility-control.component.html',
  styleUrls: ['./accessibility-control.component.scss'],

  animations: [
    trigger('slideIcon', [
      state('initial', style({
        transform: 'translateX(0)'
      })),
      state('moved',
        style({
          transform: 'translateX(215px)'
        })),
      transition('initial => moved', [
        animate('0.3s ease-out')
      ]),
      transition('moved => initial', [
        animate('0.3s ease-in')
      ])
    ]),
    trigger('accessibilityMenu', [
      state('visible', style({
        opacity: 1,
        visibility: 'visible'
      })),
      state('hidden', style({
        opacity: 0,
        visibility: 'hidden'
      })),
      transition('visible => hidden', [
        animate('0.3s ease-out')
      ]),
      transition('hidden => visible', [
        animate('0.3s ease-in')
      ])
    ])
  ]
})
export class AccessibilityControlComponent {

  iconState = 'initial';
  menuState = 'hidden';

  @Select(SharedState.brandName)
  brand$: Observable<string>;

  constructor(private accessibilityService: AccessibilityService, private elementRef: ElementRef) {
  }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent): void {

    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside || this.iconState !== 'initial') {
      this.menuState = 'hidden';
      this.iconState = 'initial';
    } else {
      this.iconState = 'moved';
    }
  }

  toggleContrast(): void {
    this.accessibilityService.toggleContrast();
  }

  onClickShow(): void {
    if (this.iconState === 'moved') {
      this.menuState = 'visible';
    }
  }

  barrierFreeInfo(): Observable<string> {
    return this.brand$.pipe(map(brand => this.accessibilityService.getBarrierFreeInfoPath(brand)));
  }
}
